<template>
  <div>
	<div class="slider-banner banner">
		<swiper :options="swiperOption" v-if="banner.length > 0">
			<swiper-slide v-for="(item, index) in banner" :key="index">
				<router-link :to="item.wap_url ? item.wap_url : ''" class="search acea-row row-middle">
					<img :src="item.pic" />
				</router-link>
			</swiper-slide>
			<div class="swiper-pagination" slot="pagination"></div>
		</swiper>
	</div>
	<div class="nav-vipstore">
		<div class="nav-item" v-for="(item, index) in menus" :key="index">
			<router-link :to="'vipcate?id='+item.id" class="item">
				<div class="pictrue"><img :src="item.pic" /></div>
				<div>{{ item.cate_name }}</div>
			</router-link>
		</div>
	</div>
	<div class="nav-vipstore" style="width:90%;margin: 0 auto;background: #fff;padding:10px 0;margin-bottom:10px;line-height: 20px;">
		<span>积分欢乐购</span>  <span>当前积分 <span style="color:#1CC74C;font-size:1.5em;vertical-align: middle;">{{integral}}</span></span>
	</div>
   <!-- <div class="hot">
			<div class="hot-title">热门榜单</div>
			<div class="hot-con">
				<div class="hot-item" v-for="(item, index) in likeInfo" :key="index">
					<router-link :to="'/detail?id=' + item.id + '&mid=' + item.merchant_id + '&type=' + 3" class="router-link">
						<div class="hot-left"><img :src="item.image" mode="" class="hot-dian"></img></div>
						<div class="hot-right" style="padding:0">
							<div class="hot-word">{{item.store_name}}</div>
							<div class="hot-pw">
								<span  class="span2" style="vertical-align: middle; display: inline-block;width:100%">￥{{item.price}}/元</span>
								<img src="../../assets/yuyue/hot_icon.png" mode="" class="hot-icon"></img>
							</div>
						</div>
					</router-link>
				</div>
			</div>
	</div> -->
    <div class="service">
      <div class="service-title">服务承诺</div>
      <div class="sevice-con">
        <div class="sevice-item">
          <div class="sevice-left">
            <img src="../../assets/yuyue/service1.png"></img>
          </div>
          <div class="sevice-right">
            <div class="service-word">安全无忧</div>
            <div class="service-one">多重保障</div>
            <div class="service-one">守护放心消费</div>
          </div>
        </div>
        <div class="sevice-item">
          <div class="sevice-left">
            <img src="../../assets/yuyue/service2.png"></img>
          </div>
          <div class="sevice-right">
            <div class="service-word">退货无忧</div>
            <div class="service-one">假一赔三</div>
            <div class="service-one">正品保障</div>
          </div>
        </div>
        <div class="sevice-item">
          <div class="sevice-left">
            <img src="../../assets/yuyue/service3.png"></img>
          </div>
          <div class="sevice-right">
            <div class="service-word">价格透明</div>
            <div class="service-one">收费标准公开</div>
            <div class="service-one">价格定制合理</div>
          </div>
        </div>
        <div class="sevice-item">
          <div class="sevice-left">
            <img src="../../assets/yuyue/service4.png"></img>
          </div>
          <div class="sevice-right">
            <div class="service-word">质量保证</div>
            <div class="service-one">高质量维修</div>
            <div class="service-one">专业技术人员</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="word">下单成功后，服务人员接单后将及时上门</div> -->

    <!-- <home></home> -->
    <!-- <tabBar></tabBar> -->
    <!-- <peisong v-if="showType == 'peisong'" @outLoginFun="outLoginFun"></peisong> -->
  </div>
</template>
<script>
	import { getUser } from "@api/user";
	import { swiper, swiperSlide } from "vue-awesome-swiper";
	import { getIntegralIndex } from "@api/store";
	import "@assets/css/swiper.min.css";
	export default{
		name: "vipStore",
		components: {
			swiper,
			swiperSlide,
			// GoodList,
			// PromotionGood,
			// CouponWindow
		},
		data(){
			console.log(this.$route.index);
			return{
				banner:"",
				category:'',
				integral:"",
				productList:[
					{
						cate_id: "39",
						diamond_price: "14.40",
						gold_price: "0.00",
						id: 8242,
						image: "http://app.funengtuan.com//uploads/attach/2020/07/20200717/327b2aed8ef049ed937d2c6bea6ea325.jpg",
						price: "18.00",
						sales: "105",
						stock: 3,
						store_name: "化痰平喘片",
						vip_price: "14.40",
					},
					{
						cate_id: "39",
						diamond_price: "14.40",
						gold_price: "0.00",
						id: 8242,
						image: "http://app.funengtuan.com//uploads/attach/2020/07/20200717/327b2aed8ef049ed937d2c6bea6ea325.jpg",
						price: "18.00",
						sales: "105",
						stock: 3,
						store_name: "化痰平喘片",
						vip_price: "14.40",
					},
					{
						cate_id: "39",
						diamond_price: "14.40",
						gold_price: "0.00",
						id: 8242,
						image: "http://app.funengtuan.com//uploads/attach/2020/07/20200717/327b2aed8ef049ed937d2c6bea6ea325.jpg",
						price: "18.00",
						sales: "105",
						stock: 3,
						store_name: "化痰平喘片",
						vip_price: "14.40",
					},
					{
						cate_id: "39",
						diamond_price: "14.40",
						gold_price: "0.00",
						id: 8242,
						image: "http://app.funengtuan.com//uploads/attach/2020/07/20200717/327b2aed8ef049ed937d2c6bea6ea325.jpg",
						price: "18.00",
						sales: "105",
						stock: 3,
						store_name: "化痰平喘片",
						vip_price: "14.40",
					},
				],
				likeInfo:[
					{
						id:27,
						img:'http://chaoteng.93px.com/uploads/attach/2020/07/20200724/6734e4384cda19f91e9154b982133a3a.png',
						store_name:'洗衣机维修'
					},
					{
						id:27,
						img:'http://chaoteng.93px.com/uploads/attach/2020/07/20200724/6734e4384cda19f91e9154b982133a3a.png',
						store_name:'洗衣机维修'
					},
					{
						id:27,
						img:'http://chaoteng.93px.com/uploads/attach/2020/07/20200724/6734e4384cda19f91e9154b982133a3a.png',
						store_name:'洗衣机维修'
					},
					{
						id:27,
						img:'http://chaoteng.93px.com/uploads/attach/2020/07/20200724/6734e4384cda19f91e9154b982133a3a.png',
						store_name:'洗衣机维修'
					},
				],
				menus:[
					/* {
						id:99,
						name:'药品商城',
						pic:'http://app.funengtuan.com//uploads/attach/2020/06/20200624/15363b7d694401cbcd11fd8c12c410e8.png',
						show:'1',
						url:'/pages/goods_cate/goods_cate?index=' + 1,
						wap_url:'/category?index=' + 3
					},
					{
						id:99,
						name:'药品商城',
						pic:'http://app.funengtuan.com//uploads/attach/2020/06/20200624/15363b7d694401cbcd11fd8c12c410e8.png',
						show:'1',
						url:'/pages/goods_cate/goods_cate',
						wap_url:'/category'
					},
					{
						id:99,
						name:'药品商城',
						pic:'http://app.funengtuan.com//uploads/attach/2020/06/20200624/15363b7d694401cbcd11fd8c12c410e8.png',
						show:'1',
						url:'/pages/goods_cate/goods_cate',
						wap_url:'/category'
					},
					{
						id:99,
						name:'药品商城',
						pic:'http://app.funengtuan.com//uploads/attach/2020/06/20200624/15363b7d694401cbcd11fd8c12c410e8.png',
						show:'1',
						url:'/pages/goods_cate/goods_cate',
						wap_url:'/category'
					},
					{
						id:99,
						name:'药品商城',
						pic:'http://app.funengtuan.com//uploads/attach/2020/06/20200624/15363b7d694401cbcd11fd8c12c410e8.png',
						show:'1',
						url:'/pages/goods_cate/goods_cate',
						wap_url:'/category'
					},
					{
						id:99,
						name:'药品商城',
						pic:'http://app.funengtuan.com//uploads/attach/2020/06/20200624/15363b7d694401cbcd11fd8c12c410e8.png',
						show:'1',
						url:'/pages/goods_cate/goods_cate',
						wap_url:'/category'
					},
					{
						id:99,
						name:'药品商城',
						pic:'http://app.funengtuan.com//uploads/attach/2020/06/20200624/15363b7d694401cbcd11fd8c12c410e8.png',
						show:'1',
						url:'/pages/goods_cate/goods_cate',
						wap_url:'/category'
					},
					{
						id:99,
						name:'药品商城',
						pic:'http://app.funengtuan.com//uploads/attach/2020/06/20200624/15363b7d694401cbcd11fd8c12c410e8.png',
						show:'1',
						url:'/pages/goods_cate/goods_cate',
						wap_url:'/category'
					}, */
				]
			}
		},
		mounted: function() {
		  // document.addEventListener("scroll", this.onScroll, false);
		  this.loadCategoryData();
		},
		methods:{
			loadCategoryData() {
			  // console.log(123);
			  // getIntegralCategory().then(res => {
			  //   console.log(res);
			  //   this.category = res.data;
			    // this.category =
			    // this.$nextTick(() => {
			    //   if (this.$route.params.pid) this.activeCateId(this.$route.params.pid);
			    //   else this.onScroll();
			    // });
			  // });
			  getIntegralIndex().then(res => {
			    console.log(res);
			    this.banner = res.data.banner;
			    this.likeInfo = res.data.bastList;
				this.menus = res.data.menus;
				this.integral=res.data.integral
			  });
			},
		}
	}
</script>

<style>
/* @import "./index.css"; */
.app {
  background-color: #fff !important;
}
.search {
  width: 100%;
  /* height: 70px;sss */
  /* padding: 15px;ss */
  box-sizing: border-box;
}
.search > input {
  width: 100%;
  height: 100%;
  border-radius: 25px;
  padding: 5px 15px;
  box-sizing: border-box;
  background-color: #f6f6f6;
}
.banner {
  width: 100%;
  /* height: 150px;ss */
  /* padding: 5px 15px;ss */
}
.banner > img {
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.nav-vipstore {
  width: 100%;
  height: auto;
  padding: 20px 0;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}
.nav-item {
  width: 25%;
  text-align: center;
  font-size: 13px;
  margin-bottom:17px;
}
.nav-item img {
  width: 45px;
  height: 45px;
  margin: 0 auto 7px auto;
}
.nav-item .nav-word {
  /* display: block;
	font-size: 30rpx;
	text-align: left;
	margin-left: 20rpx; */
  text-align: center;
  font-size: 13px;
}
/* 热门推荐 */
.hot {
  width: 100%;
  height: auto;
  padding: 0px 10px 20px;
  box-sizing: border-box;
}
.hot-title {
  font-size: 17px;
  font-weight: 500;
  margin-bottom: 15px;
}
.hot-con {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.hot-item {
  width: 48%;
  height: 87px;
  margin-bottom: 10px;
}
.hot-item .router-link {
  width: 100%;
  height: 100%;
  padding: 10px;
  position: relative;
  background: url(../../assets/yuyue/hot_bg.png) repeat;
  box-sizing: border-box;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  border-radius: 10px;
}
.hot-left {
  width: 50%;
  height: 60px;
}
.hot-left img {
  width: 60px;
  height: 60px;
}
.span2{
	width: 40px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.hot-right {
  width: 50%;
  height: 60px;
  /* padding-left: 10px; */
}
.hot-word {
  font-size: 13px;
  font-weight: 500;
  display: inline-block;
  width: 60px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.hot-pw{
	margin-top: 20px;
}
.hot-icon {
  width: 10px;
  height: 10px;
  margin-top: 2px;
  float: right;
}
.service {
  width: 100%;
  height: auto;
  padding: 10px 14px;
  box-sizing: border-box;
}
.service-title {
  font-size: 17px;
  font-weight: 500;
  margin-bottom: 15px;
}
.sevice-con {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.sevice-item {
  width: 48%;
  height: 87px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-around;
}
.sevice-left {
  width: 40%;
  height: 65px;
}
.sevice-left img {
  width: 50px;
  height: 65px;
}
.sevice-right {
  width: 60%;
  height: 65px;
}
.service-word {
  font-size: 13px;
  font-weight: 700;
  line-height: 22px;
}
.service-one {
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
}
.process {
  width: 100%;
  height: 130px;
  padding: 10px 14px;
  box-sizing: border-box;
}
.process-title {
  font-size: 17px;
  font-weight: 500;
  margin-bottom: 15px;
  width: 100%;
}
.process-con {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  position: absolute;
  width: 100%;
  /* padding: 0 30rpx; */
  box-sizing: border-box;
}
.process-con > img {
  width: 75%;
  height: 5px;
  position: absolute;
  top: 18px;
  left: 15px;
}
.process-item {
  width: 25%;
  height: 50px;
}
.process-item > img {
  width: 40px;
  height: 40px;
  margin-left: 25%;
  transform: translateX(-50%);
}
.process-word {
  font-size: 13px;
  font-weight: 700;
}
.word {
  font-size: 13px;
  color: #999;
  margin-left: 30px;
  margin-bottom: 50px;
}
</style>
